module.exports = __webpack_public_path__ + "img/云端监控.7a35eb77.png";